<template>
  <div class="box" :class="[width_class, tips_class]">
    {{ text }}
    <a class="href" :href="href">{{ href }}</a>
    {{text_2}}
    <a class="href" :href="href_2">{{ href_2 }}</a>
    {{text_3}}
  </div>
</template>

<script>
export default {
  name: "MainDescribe",
  props: {
    text: {type: String},
    href: {type: String, default: ''},
    text_2: {type: String, default: ''},
    href_2: {type: String, default: ''},
    text_3: {type: String, default: ''},
    width_class: {type: String, default: 'short_width'},
    tips_class: {type: String, default: ''},
  }
}
</script>

<style scoped>
.box {
  margin: 0 auto;
  /*width: 62%;*/
  font-size: var(--ecs-font-md);
}

.href {
  font-size: var(--ecs-font-sm);
  color: #94c43c;
  text-decoration: none;
}
.short_width{
  width: 62%;
}
.long_width{
  width: 100%;
}
.tips{
  transform: translate(32%, 0);
  float: left;
  clear: both;
  font-size: var(--ecs-font-sm);
}


</style>
